import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  CssBaseline,
  Paper,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../actions/getUserData";
import { setAppLoader } from "../actions/setAppLoader";
import { saveFormPath } from "../services/userService";
import ErrorModal from "../components/common/ErrorModal";
import CAlert from "../components/utils/CAlert";
import CButton from "../components/utils/CButton";
import { createMandate, createPayment, getMandateStatus, getPaymentStatus, updateLeadApi } from "../services/avanseService";
import CircularLoader from "../components/utils/CircularLoader";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import FlyLogo from "../assets/images/flyhi_logo_full.svg";
import signUPImage from "../assets/images/signUP.svg";
import CStepper from "../components/utils/CStepper";
import CMenu from "../components/utils/CMenu";
import MobileViewHeader from "../components/header/MobileViewHeader";
import { set } from "date-fns";
import { ca } from "date-fns/locale";

export default function AvansePaymentFlow({ setTabValue, setStepperCount }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const [isFetching, setIsFetching] = React.useState(false);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [technicalError, setTechnicalError] = React.useState(false);
  const [verificationStatus, setVerificationStatus] = React.useState("FAILED");
  const disabledButton = verificationStatus !== "SUCCESS";
  const [pollingCount, setPollingCount] = React.useState(0);
  const [isPolling, setIsPolling] = React.useState(false);
  const [hasUserInitiated, setHasUserInitiated] = React.useState(false);
  const [paymentWebUrl, setPaymentWebUrl] = React.useState("");
  const pollingIntervalRef = React.useRef(null);
  const stepperCount = 7;
  const theme = useTheme();
  const userDetailId = localStorage.getItem("detailId");

  useEffect(() => {
    dispatch(getUserData(userDetailId || localStorage.getItem("detailId")));
  }, [dispatch, userDetailId]);

  useEffect(() => {
    const fetchMandateStatus = async () => {
      try {
        const status = await getPaymentStatus(
          userDetailId || localStorage.getItem("detailId")
        );
        setVerificationStatus(status.response?.paymentStatusUi);
        setPaymentWebUrl(status.response?.paymentLink);
        console.log("Payment status check:::::", status);
      } catch (error) {
        console.error("Error fetching payment status:", error);
      } finally {
        setIsFetching(false);
      }
    };

    if (userDetailId || localStorage.getItem("detailId")) {
      fetchMandateStatus();
    }
  }, [userDetailId]);

  const getVericationStatusMessage = (status) => {
    switch (status) {
      case "PENDING":
        return "Initiate PAYMENT";
      case "INITIATE":
        return "Initiating PAYMENT...";
      case "INITIATED":
        return "Initiating PAYMENT...";
      case "IN_PROGRESS":
        if (!hasUserInitiated) {
          return "RESUME PAYMENT";
        }
        return "Processing PAYMENT...";
      case "SUCCESS":
        return "PAYMENT Completed";
      case "FAILED":
      case "EXPPIRED":
        return "Re-Initiate PAYMENT";
    }
  };

  const handleInitiatePaymentSuccess = (link) => {
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      link = "https://" + link;
    }
    setPaymentWebUrl(link);
    window.location.href = link;
  };

  //Poll getLoanStatus API every 10 seconds
  React.useEffect(() => {
    if (!isPolling || verificationStatus === "PENDING") return;

    const pollLoanStatus = async () => {
      try {
        const response = await getPaymentStatus(userDetailId);
        setPollingCount((prev) => prev + 1);
        // setVerificationStatus(response.response?.paymentStatusUi);
        setVerificationStatus('FAILED');
        setPaymentWebUrl(response.response?.paymentLink);
        console.log("Polling getLoanStatus response:", response);
        if (response?.response?.paymentStatusUi === "SUCCESS") {
          setIsPolling(false);
          saveFormPath("/loanRepayment", userDetailId);
        } else if (response?.response?.paymentStatusUi === "EXPIRED") {
          setIsPolling(false);
          setVerificationStatus("EXPIRED");
        }
      } catch (error) {
        console.error("Error polling loan status:", error);
        setPollingCount((prev) => prev + 1);
      }
    };

    pollingIntervalRef.current = setInterval(pollLoanStatus, 20000);

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [isPolling, userDetails, navigate, verificationStatus, userDetailId]);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [isFetching, dispatch]);

  React.useEffect(() => {
    console.log("verificationStatus changed:", verificationStatus);
    if (verificationStatus === "FAILED") {
      setError(true);
      setErrorMsg("Capture Payment Failed, Please Try Again");
    } else {
      setError(false);
      setErrorMsg("");
    }
  }, [verificationStatus]);

  async function initiatePaymentProcess() {
    if (!hasUserInitiated && verificationStatus === "IN_PROGRESS") {
      setHasUserInitiated(true);
      setTimeout(() => {
        setIsPolling(true);
        handleInitiatePaymentSuccess(paymentWebUrl);
      }, 1000);

      return;
    }
    if (verificationStatus !== "PENDING" && verificationStatus !== "EXPIRED" && verificationStatus !== "FAILED") {
      return;
    }
    setHasUserInitiated(true);
    setIsPolling(true);
    setVerificationStatus("INITIATE");
    createPayment(userDetailId).then((res) => {
      console.log("initiateDigilocker::::res", res);
      if (res?.success) {
        setVerificationStatus("INITIATED");
        setError(false);
        setErrorMsg("");
        setPaymentWebUrl(res?.response?.shortUrl);
        handleInitiatePaymentSuccess(res?.response?.shortUrl);
      } else {
        setTechnicalError(true);
        setVerificationStatus('FAILED');
      }
    });
  }

  // On Save and submit
  async function onSubmitVerified(e) {
    e.preventDefault();
    console.log("Submitting payment verificationStatus:", verificationStatus);
    if (verificationStatus !== "SUCCESS" && verificationStatus !== "PAYMENT") {
      setError(true);
      setErrorMsg("Please Initiate Payment to proceed");
      return;
    }

    updateLeadApi(userDetailId);
    saveFormPath("/loanCompleted", userDetails?.detailId);
    dispatch(getUserData(userDetailId));
    navigate("/loanCompleted", {
        state: { tabValue: 9, stepperCount: 5, userDetailId: userDetailId },
      });
  }

  function handleBack() {
    navigate("/avanse/nach", {
      state: {
        tabValue: 3,
        stepperCount: 3,
        userDetailId: userDetailId || localStorage.getItem("detailId"),
      },
    });
  }

  function renderPaymentComponent() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Advance EMI & Processing fee Payment
        </Typography>

        <Grid container rowSpacing={1} justifyContent="center">
          <Grid item xs={12} sm={8} md={6} className="digilocker-button">
            {verificationStatus !== "PENDING" &&
              verificationStatus !== "SUCCESS" &&
              hasUserInitiated && (
                <Grid item justifyContent="center" style={{ display: "grid" }}>
                  <CircularLoader></CircularLoader>
                </Grid>
              )}
            {verificationStatus === "IN_PROGRESS" && !hasUserInitiated && (
              <Grid item justifyContent="center" style={{ display: "gird" }}>
                <Typography
                  color="textColor"
                  variant="body2"
                  sx={{ textAlign: "center" }}
                >
                  Looks like you have initiated the payment process
                  already. Please complete it by clicking on RESUME PAYMENT
                  button.
                </Typography>
              </Grid>
            )}

            <CButton
              handleClick={initiatePaymentProcess}
              variant={
                (verificationStatus === "PENDING" ||
                  verificationStatus === "IN_PROGRESS") &&
                !hasUserInitiated
                  ? "contained"
                  : "outlined"
              }
              name={getVericationStatusMessage(verificationStatus)}
              mt={4} // Adjust width as necessary
            />
            {verificationStatus === "SUCCESS" && (
              <Grid
                item
                justifyContent="center"
                style={{ display: "gird", marginTop: "16px" }}
              >
                {verificationStatus === "SUCCESS" ? (
                  <Typography
                    color="textColor"
                    variant="body2"
                    sx={{ textAlign: "center" }}
                  >
                    Payment process completed successfully.
                  </Typography>
                ) : (
                  <Typography
                    color="textColor"
                    variant="body2"
                    sx={{ textAlign: "center" }}
                  >
                    Click the above button to initiate register process.
                  </Typography>
                )}
              </Grid>
            )}
            {errorMsg && (
            <Grid item>
              <Typography
                color="textColor"
                variant="body2"
                sx={{ textAlign: "center", color: "red" }}
              >
                {errorMsg}
              </Typography>
            </Grid>
          )}
          </Grid>

          
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <div style={{ height: "auto" }}>
      {/* <CAlert /> */}
      <AppBar
        sx={{ backgroundColor: theme.palette.headerColor }}
        position="static"
      >
        {matches ? (
          <Container maxWidth="xl">
            <Toolbar
              sx={{
                display: "grid",
                gridAutoFlow: "column",
                justifyContent: "space-between",
              }}
              disableGutters
            >
              <img
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "50px",
                  height: "50px",
                }}
                src={FlyLogo}
                alt="logo"
              />
              <div
                sx={{
                  pt: 6,
                  gridColumn: "3 / 5",
                  display: { xs: "none", md: "block", lg: "none" },
                }}
              >
                <CStepper tabValue={stepperCount} />
              </div>
              <div
                onClick={() => handleBack()}
                sx={{
                  gridColumn: "4 / 5",
                  textAlign: "left",
                  fontFamily: "lato",
                  cursor: "pointer",
                }}
                variant="body1"
              >
                <CMenu />
              </div>
            </Toolbar>
          </Container>
        ) : (
          <MobileViewHeader
            stepperCount={stepperCount + 1}
            header="Loan Agreement"
            nextHeader="Loan Agreement"
          />
        )}
      </AppBar>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />

        <Grid item xs={12} sm={6} md={6} component={Paper}>
          <form
            onSubmit={(e) => onSubmitVerified(e)}
            className="applicationFormContainer"
          >
            {error && (
              <CAlert open={error} message={errorMsg} severity="error" />
            )}

            {!matches && (
              <Box sx={{ display: "flex" }}>
                <ArrowBackIosIcon onClick={() => handleBack()} />
              </Box>
            )}

            {renderPaymentComponent()}

            {technicalError && (
              <ErrorModal
                open={technicalError}
                setOpen={setTechnicalError}
                isTechnicalError={true}
              />
            )}
          </form>
        </Grid>
        <Grid
          item
          display={{ xs: "none", lg: "block", sm: "block" }}
          sm={6}
          md={6}
          sx={{
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <img src={signUPImage} alt="signup" />
        </Grid>
      </Grid>
    </div>
  );
}
